export enum snackbarLocationEnum {
    topRight,
    bottomRight,
}
